module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-exclusives-5-5113fa40819c93fafef7f6d56025b4bc.jpg";